import { TabOption } from '@/components/chariot-ui';

/**
 * Tab configuration for Asset Drawer
 */
export const ASSET_DRAWER_TABS = {
  OVERVIEW: '',
  APPLICATION: 'application',
  VULNERABILITIES: 'vulnerabilities',
  ATTRIBUTES: 'attributes',
  HISTORY: 'history',
  AFFILIATION: 'affiliation',
  NOTES: 'notes',
} as const;

/**
 * Tab labels for Asset Drawer tabs
 */
export const ASSET_DRAWER_TAB_LABELS: Record<string, string> = {
  [ASSET_DRAWER_TABS.OVERVIEW]: 'Overview',
  [ASSET_DRAWER_TABS.APPLICATION]: 'Application',
  [ASSET_DRAWER_TABS.VULNERABILITIES]: 'Vulnerabilities',
  [ASSET_DRAWER_TABS.ATTRIBUTES]: 'Attributes',
  [ASSET_DRAWER_TABS.HISTORY]: 'History',
  [ASSET_DRAWER_TABS.AFFILIATION]: 'Affiliation',
  [ASSET_DRAWER_TABS.NOTES]: 'Notes',
};

/**
 * Tab options for Asset Drawer navigation
 */
export const ASSET_DRAWER_TAB_OPTIONS: TabOption[] = [
  {
    label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.OVERVIEW],
    value: ASSET_DRAWER_TABS.OVERVIEW,
  },
  {
    label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.VULNERABILITIES],
    value: ASSET_DRAWER_TABS.VULNERABILITIES,
  },
  {
    label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.ATTRIBUTES],
    value: ASSET_DRAWER_TABS.ATTRIBUTES,
  },
  {
    label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.HISTORY],
    value: ASSET_DRAWER_TABS.HISTORY,
  },
  {
    label: ASSET_DRAWER_TAB_LABELS[ASSET_DRAWER_TABS.NOTES],
    value: ASSET_DRAWER_TABS.NOTES,
  },
];
